document.addEventListener("DOMContentLoaded", function () {
  const tabsList = document.querySelector(
    ".section-tab-scrolling .c-container .content-tabs .tabs-list"
  );
  if (tabsList) {
    tabsList.addEventListener("wheel", function (e) {
      if (e.deltaY !== 0) {
        e.preventDefault();
        tabsList.scrollLeft += e.deltaY;
      }
    });

    tabsList.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        const links = tabsList.querySelectorAll("a");
        links.forEach((link) => link.classList.remove("active"));
        e.target.classList.add("active");
      }
    });

    tabsList.querySelectorAll("a").forEach(function (tab) {
      tab.addEventListener("click", function (e) {
        const targetId = tab.getAttribute("href").replace("#", "");
        const target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          const offset = 150;
          const top =
            target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top, behavior: "smooth" });
        }
      });
    });
  }

  document
    .querySelectorAll("[data-subscription-toggle]")
    .forEach(function (toggle) {
      const section = toggle.closest(".section-card-collections");
      if (!section) return;

      const applyState = function (isActive) {
        toggle.classList.toggle("is-active", isActive);
        toggle.setAttribute("aria-pressed", isActive ? "true" : "false");
        section.classList.toggle("subscription-disabled", !isActive);

        section
          .querySelectorAll('input[name="selling_plan"]')
          .forEach(function (input) {
            if (!input.dataset.originalValue) {
              input.dataset.originalValue = input.value || "";
            }
            input.value = isActive ? input.dataset.originalValue : "";
            input.disabled = !isActive;
          });
      };

      applyState(toggle.classList.contains("is-active"));

      toggle.addEventListener("click", function () {
        applyState(!toggle.classList.contains("is-active"));
      });
    });

  let lastTriggerEl = null;

  function refreshCartDrawer() {
    return fetch(window.location.pathname + "?sections=cart-drawer")
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newDrawer = doc.querySelector("cart-drawer");
        const drawer = document.querySelector("cart-drawer");
        if (drawer && newDrawer) {
          drawer.innerHTML = newDrawer.innerHTML;
          if (typeof drawer.open === "function") {
            drawer.open();
          } else {
            drawer.classList.add("active");
            drawer.style.visibility = "visible";
          }
          if (typeof window.showCartDrawer === "function") {
            window.showCartDrawer();
          }
        }
      });
  }

  function submitCardForm(form, asSubscription, submitBtn) {
    if (!form) return;
    const formData = new FormData(form);
    if (!asSubscription) {
      formData.delete("selling_plan");
    } else if (!formData.get("selling_plan")) {
      formData.delete("selling_plan");
    }

    if (submitBtn) {
      submitBtn.disabled = true;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            throw new Error(data.description || data.message || "Cart error");
          }
          return data;
        });
      })
      .then(function () {
        return refreshCartDrawer();
      })
      .catch(function (error) {
        alert("Error adding to cart: " + error.message);
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
        }
      });
  }

  function openSubscriptionModal(modal, trigger) {
    if (!modal) return;
    lastTriggerEl = trigger || null;
    modal.removeAttribute("hidden");
    modal.setAttribute("aria-hidden", "false");
    void modal.offsetWidth;
    modal.classList.add("is-open");
    document.body.classList.add("subscription-modal-open");
    const dialog = modal.querySelector(".subscription-modal__dialog");
    if (dialog) dialog.focus({ preventScroll: true });
  }

  function closeSubscriptionModal(modal) {
    if (!modal || !modal.classList.contains("is-open")) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("subscription-modal-open");
    const onEnd = function () {
      modal.setAttribute("hidden", "");
      modal.removeEventListener("transitionend", onEnd);
    };
    modal.addEventListener("transitionend", onEnd);
    setTimeout(onEnd, 400);
    if (lastTriggerEl && typeof lastTriggerEl.focus === "function") {
      lastTriggerEl.focus();
    }
    lastTriggerEl = null;
  }

  document
    .querySelectorAll(".section-card-collections .card-collection")
    .forEach(function (card) {
      const form = card.querySelector("[data-card-form]");
      const addBtn = card.querySelector(".add-to-cart-btn");
      const modal = card.querySelector("[data-subscription-modal]");

      if (form) {
        form.addEventListener("submit", function (e) {
          e.preventDefault();
        });
      }

            if (addBtn && form) {
        addBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const section = card.closest(".section-card-collections");
          const subscriptionEnabled =
            section && !section.classList.contains("subscription-disabled");

          // Skip the popup — add directly using the toggle's current state
          submitCardForm(form, subscriptionEnabled, addBtn);
        });
      }

      if (modal) {
        modal
          .querySelectorAll("[data-subscription-modal-close]")
          .forEach(function (el) {
            el.addEventListener("click", function () {
              closeSubscriptionModal(modal);
            });
          });

        modal
          .querySelectorAll("[data-subscription-modal-submit]")
          .forEach(function (btn) {
            btn.addEventListener("click", function () {
              const asSubscription = btn.dataset.submitMode === "subscription";
              closeSubscriptionModal(modal);
              submitCardForm(form, asSubscription, btn);
            });
          });
      }
    });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document
      .querySelectorAll("[data-subscription-modal].is-open")
      .forEach(function (modal) {
        closeSubscriptionModal(modal);
      });
  });
});